export { default } from './RowOfImageTextBlocks'
